import { Box, Button, ListItem, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { restoreMacro } from "authoring/routes/macro/controller/restore-macro"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { formatMacroDate } from "authoring/routes/macro/lib/macro-formatters"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_MANAGE_MACROS_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function MacroBinItem({ macro }) {
    const { onRestore } = useBoundContext()
    if (!macro) return null
    const { name: macroName, id } = macro ?? {}
    const deletedLabel = formatMacroDate(macro.modified)

    return (
        <ListItem
            divider
            disableGutters
            data-cy={`macro-bin-item-${id}`}
            secondaryAction={
                <Secure demand={AUTHORING_MANAGE_MACROS_DEMAND} fallback={<Frag />}>
                    <Button
                        variant="text"
                        size="small"
                        color="primary"
                        startIcon={<Iconify icon="ic:baseline-restore" />}
                        onClick={handleRestore}
                        data-cy={"macro-restore-button"}
                    >
                        Restore
                    </Button>
                </Secure>
            }
        >
            <Stack direction="row" spacing={2} alignItems="center" sx={{ width: 1, pr: 2 }}>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography variant="subtitle2" sx={{ lineHeight: 1.2 }}>
                        {macroName}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" data-cy="macro-bin-item-deleted-date">
                        Deleted {deletedLabel}
                    </Typography>
                </Box>
            </Stack>
        </ListItem>
    )

    async function handleRestore() {
        try {
            const restored = await restoreMacro({ id })
            if (!restored) {
                errorSnackbar("Failed to restore macro")
                return
            }

            successSnackbar("Macro restored")
            if (onRestore) {
                onRestore(macro)
            }
        } catch (error) {
            console.error(error)
            errorSnackbar("Failed to restore macro")
        }
    }
}
